import DevourClient from 'devour-client';

export const TYPE = 'setting';

export default function (client: DevourClient) {
	client.define(
		TYPE,
		{
			name: '',
			value: '',
		},
		{
			type: TYPE,
		}
	);

	return client;
}
